// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8f9eb63","732":"e125677c","952":"5e07081c","977":"63301410"}[chunkId] + ".chunk.js";
};